import { DATASOURCE_BY_TABLE_TYPES } from '../IngestionByDataSource/IngestionByDataSource.constants';

export const getNoTablesFoundText = (dataSourceType: keyof typeof DATASOURCE_BY_TABLE_TYPES) => {
  const typeLabel = DATASOURCE_BY_TABLE_TYPES?.[dataSourceType]?.toLowerCase() || '';

  return {
    empty: `This data source does not have any ${typeLabel}s.`,
    noneFound: `There are no matching ${typeLabel}s. Please try a different search.`,
    errors: {
      default: `There was an error loading the ${typeLabel}s.`,
    },
  };
};
